document.addEventListener('DOMContentLoaded', function() {
  // Handle shade picker
  const shadePicker = document.querySelector('[data-shade-picker]');
  if (shadePicker) {
    const swatches = shadePicker.querySelectorAll('.shade-swatch');
    const variantSelect = document.querySelector('select[name="options[Shade]"]');

    if (variantSelect) {
      swatches.forEach(swatch => {
        swatch.addEventListener('click', function() {
          if (this.classList.contains('sold-out')) return;

          const variantValue = this.getAttribute('data-variant-value');
          const matchingOption = Array.from(variantSelect.options)
            .find(option => option.value === variantValue);

          if (matchingOption) {
            // Update select value
            variantSelect.value = matchingOption.value;
            
            // Get the variant ID and update URL
            const variantId = this.getAttribute('data-variant-id');
            const url = new URL(window.location);
            url.searchParams.set('variant', variantId);
            
            // Refresh the page with new variant
            window.location = url.toString();
          }
        });
      });
    }
  }

  // Handle regular variant selector
  const variantSelectors = document.querySelectorAll('.dynamic-variant-input');
  
  variantSelectors.forEach(selector => {
    selector.addEventListener('change', function(e) {
      const variantJson = JSON.parse(document.querySelector('[data-variant-json]').textContent);
      const selectedValue = this.value;
      
      // Find the matching variant
      const selectedVariant = variantJson.find(variant => 
        variant.option1 === selectedValue
      );

      if (selectedVariant) {
        const url = new URL(window.location);
        url.searchParams.set('variant', selectedVariant.id);
        window.location = url.toString();
      }
    });
  });
});